import React from 'react';

import { faUsers } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CheckboxFilter from 'bundles/backoffice/filters/checkbox';

import type { BrokerOption } from '../types';
import type { Filters, SelectOption } from './types';
import UserIcon from 'components/user_icon';
import { faUserGroupSimple } from '@fortawesome/pro-regular-svg-icons';
import { FormLabel } from 'react-bootstrap-5';

type Slice = Pick<Filters, 'brokers'>;
interface Props extends Slice {
  brokerOptions: BrokerOption[];
  onChange: (changes: Slice) => void;
}

function getBrokerOption(broker: BrokerOption): SelectOption {
  return {
    label: (
      <div className="d-flex align-items-center py-1 gap-1">
        {broker.imageUrl ? (
          <UserIcon size="sm" user={broker} />
        ) : (
          <FontAwesomeIcon className="text-muted" icon={faUsers} />
        )}
        {broker.name}
      </div>
    ),
    value: broker.id.toString(),
  };
}

function getInputText(selected: string[], brokers: BrokerOption[]) {
  if (selected.length === 0) {
    return 'All Brokers';
  }

  const selectedBrokers = brokers.filter(broker => selected.includes(String(broker.id)));
  if (selectedBrokers.length === 1) {
    return selectedBrokers[0].name;
  } else if (selectedBrokers.length === brokers.length) {
    return 'All Brokers';
  }

  return `${selectedBrokers[0].name}, +${selectedBrokers.length - 1}`;
}

export default function ActivityBrokerFilter({ brokers, brokerOptions, onChange }: Props) {
  return (
    <div className="flex-grow-1">
      <FormLabel>Created By:</FormLabel>
      <CheckboxFilter
        addFilter={(_name, filter) => onChange({ brokers: [...brokers, filter] })}
        buttonIcon={faUserGroupSimple}
        className="text-truncate"
        hideSelectedCount={!brokers.length}
        label={getInputText(brokers, brokerOptions)}
        options={brokerOptions.map(getBrokerOption)}
        removeFilter={(_name, filter) => onChange({ brokers: brokers.filter(t => t !== filter) })}
        selected={brokers}
      />
    </div>
  );
}
